<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <a-form-item style="margin: 0;float: right;">
        <a-button icon="plus" type="primary" primary @click="clickAdd()">添加</a-button>
      </a-form-item>
      <a-form-item>
        <a-input v-model="name" allowClear @pressEnter="init_data" placeholder="菜单">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData"
             style="background: #ffffff;" :loading="tableLoad" :rowKey="item=>item.id"
             bordered :pagination="false">

      <template slot="handle" slot-scope="text,recode">
        <a-button size="small" @click="clickEdit(recode)">编辑</a-button>
      </template>
    </a-table>

    <OldgbMenuEditDialog
          :show-dialog="editDialogShow"
          :menuInfo="dataInfo"
          :menuList="menuList"
          :type="type"
          @close-dialog="closeEditDialog()"></OldgbMenuEditDialog>
  </div>
</template>

<script>
import {GetOldgbMenu} from "@/api/v1/menu_api";
import OldgbMenuEditDialog from "@/components/V1/OldgbMenuEditDialog";

export default {
  name: "OldgbMenu",
  components: {OldgbMenuEditDialog},
  data(){
    return {
      name:'',
      type:'edit',
      tableData:[],
      tableLoad:false,
      editDialogShow:false,
      menuList:[],
      dataInfo:{},
    }
  },
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '菜单', dataIndex: 'name',scopedSlots: { customRender: 'name' },},
        {title: '链接', dataIndex: 'url',scopedSlots: { customRender: 'url' },},
        {title: '操作', dataIndex: 'handle',scopedSlots: { customRender: 'handle' }},
      ]
      return _table_columns
    }
  },
  methods: {
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetOldgbMenu({
        name:this.name,
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data
        }
      })
    },
    changePage(page,page_size){
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    closeEditDialog(){
      this.dataInfo = {}
      this.editDialogShow = false
      this.init_data()
    },
    clickEdit (record){
      GetOldgbMenu({}).then(resp => {
        if (resp.code===200) {
          this.menuList = [{
            'id':"0",
            'key':"0",
            'title':"主菜单",
            'value':"0",
            'children':resp.data,
          }]
          record.status = record.status.toString()
          this.dataInfo = record
          this.type = 'edit'
          this.editDialogShow = true
        }
      })
    },
    clickAdd (){
      GetOldgbMenu({}).then(resp => {
        if (resp.code===200) {
          this.menuList = [{
            'id':"0",
            'key':"0",
            'title':"主菜单",
            'value':"0",
            'children':resp.data,
          }]
          
          this.dataInfo = {}
          this.type = 'add'
          this.editDialogShow = true
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/Menu/OldgbMenu.vue